/**
 * Spacer Component
 * Flexible spacer to push elements apart
 */

import React, { forwardRef } from 'react';
import { Box } from './Box';

/**
 * Spacer Component
 * Creates flexible space in flex containers
 * 
 * @example
 * <Flex>
 *   <Box>Start</Box>
 *   <Spacer />
 *   <Box>End</Box>
 * </Flex>
 */
export const Spacer = forwardRef((props, ref) => {
  return (
    <Box
      ref={ref}
      flex="1"
      justifySelf="stretch"
      alignSelf="stretch"
      {...props}
    />
  );
});

Spacer.displayName = 'Spacer';

export default Spacer;
